import { useMemo, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import { useTheme } from '@context/ThemeContext';

const PIN_ICON = L.divIcon({
  className: 'pf-map-picker-pin',
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  html: `<div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#3b82f6,#7c3aed);border:3px solid white;box-shadow:0 2px 10px rgba(59,130,246,0.5);"></div>`,
});

function MapEvents({ onPick }) {
  useMapEvents({
    click(e) {
      onPick([e.latlng.lng, e.latlng.lat]);
    },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom(), { animate: true, duration: 0.25 });
  }, [lat, lng, map]);
  return null;
}

const InlineMapPicker = ({ lat, lng, onCoordinatesChange }) => {
  const { dark } = useTheme();
  const center = useMemo(() => [lat, lng], [lat, lng]);
  const tileUrl = dark
    ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
    : 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
  const attribution = '&copy; OpenStreetMap &copy; CARTO';

  return (
    <div className="overflow-hidden rounded-2xl border border-surface-200 dark:border-surface-700">
      <MapContainer center={center} zoom={14} className="h-52 w-full z-0" scrollWheelZoom>
        <TileLayer url={tileUrl} attribution={attribution} />
        <Recenter lat={lat} lng={lng} />
        <MapEvents onPick={(coords) => onCoordinatesChange(coords)} />
        <Marker
          position={[lat, lng]}
          icon={PIN_ICON}
          draggable
          eventHandlers={{
            dragend: (e) => {
              const ll = e.target.getLatLng();
              onCoordinatesChange([ll.lng, ll.lat]);
            },
          }}
        />
      </MapContainer>
      <p className="bg-surface-50 px-3 py-2 text-[11px] text-surface-500 dark:bg-surface-900/80 dark:text-surface-400">
        Tap the map or drag the pin to set the meeting point.
      </p>
    </div>
  );
};

export default InlineMapPicker;
